import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { CreateCartPoRequest, CreateCartPoResponse } from 'src/types/cart/createPo';
import axiosInstance from 'src/utils/axios';

async function createCartPo(request: CreateCartPoRequest): Promise<CreateCartPoResponse> {
  const response = await axiosInstance.post<CreateCartPoResponse>(api.createCartPo, request);
  return response.data;
}

interface UseCreateCartPoMutationOptions {
  onSuccess?: (data: CreateCartPoResponse, request: CreateCartPoRequest) => void;
  onError?: (error: unknown) => void;
}

const useCreateCartPoMutation = ({ onSuccess, onError }: UseCreateCartPoMutationOptions = {}) =>
  useMutation({
    mutationFn: createCartPo,
    onSuccess: (data, request) => {
      onSuccess?.(data, request);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

export default useCreateCartPoMutation;
